/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { sendOtpApi } from "../../Context/sendOtpApi";
import { validateOtpApi } from "../../Context/validateOtpApi";
import { toast, ToastContainer } from "react-toastify";
import { onGenerateTokenSubmitReset } from "../../Store/Slices/generateTokenSlice";
import axiosIntegrationOtp from "../../Common/Axios/axiosIntegrationOtp";

import { decryptAES } from "../../Common/Axios/encrypt";

import Loader from "../Loader/Loader";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  ApiRespCode,
  ClientInfo,
  GenerateToken,
  GetImageUrl,
} from "../Utility/Utility";
import { handleGenerateToken } from "../OrderUtility/OrderUitlity";
import { onGetApiConfig } from "../../Store/Slices/apiConfigSlice";

const OTPModal = ({ showModal }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const translation = getTranslationData();
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [timer, setTimer] = useState(30);
  const inputs = [1, 2, 3, 4];
  const [otpData, setOtpData] = useState();
  const [orderData, setOrderData] = useState();
  const [validateOtpData, setValidateOtpData] = useState();

  const generateToken = GenerateToken();
  const loginToken = useSelector(
    (state) => state.validateLoginTokenSliceReducer,
    shallowEqual
  );
  const token = useSelector(
    (state) => state.generateTokenSliceReducer,
    shallowEqual
  );
  const [error, setError] = useState(false);
  const V3Data = useSelector(
    (state) => state.cardDataSliceReducer,
    shallowEqual
  );
  const loginTokenData = loginToken?.data?.memberProfile;


  const clientinfo = ClientInfo();
  const otpValue = otp.join("");
  const apiConfigData = useSelector(
    (state) => state.apiConfigReducer?.getApiConfig
  );

  const apiConfigMappedData = Array.isArray(apiConfigData)
    ? apiConfigData.reduce((acc, item) => {
      acc[item.paramsKey] = item.paramsValue;
      return acc;
    }, {})
    : {};
  useEffect(() => {
    if (!showModal) {
      const countdown = setInterval(() => {
        setTimer((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [showModal]);

  const handleChange = (element, index) => {
    if (isNaN(element.value) || element.value.length > 1) return;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    if (element.value && element.nextSibling) {
      element.nextSibling.focus();
    } else if (element.value === "" && element.previousSibling) {
      element.previousSibling.focus();
    }
  };
  useEffect(() => {
    dispatch(onGetApiConfig("otp"));
    if (V3Data?.ClientCode && !sessionStorage.getItem("apiCalled")) {
      sessionStorage.setItem("apiCalled", "true");

      handleGenerateToken(dispatch, V3Data);
    }
    const encData = window.location.search.slice(1);
    const decData = decryptAES(encData);
    const params = new URLSearchParams(decData);

    const orderId = params.get("orderId");
    const orderNumber = params.get("orderNumber");
    const denomination = params.get("denomination");
    const mobile = params.get("mobNumber");
    const fname = params.get("fName");
    const lname = params.get("lName");
    setOrderData({
      orderId,
      orderNumber,
      denomination,
      mobile,
      fname,
      lname,
    });

    // dispatch(
    //   onSaveDenoCard({
    //     orderId: orderId,
    //     orderNumber: orderNumber,
    //     denomination: denomination,
    //   })
    // );
  }, []);

  const [loading, setLoading] = useState(true);
  //  const templateId = apiConfigMappedData?.templateId;
  const templateId = "m001";
  const sendOtp = async () => {
    const payload = {
      mobileNumber: loginTokenData?.mobileNumber || orderData?.mobile,
      emailId: "",
      communicationChannel: 1,
      templateId: templateId,
      emailTemplateId: "",
      otpAttributes: [],
      clientCode: V3Data?.ClientCode,
      partnerCode: V3Data?.partnerCode,
    };
    axiosIntegrationOtp.defaults.headers[
      "access-token"
    ] = `${generateToken?.data?.accessToken}`;
    try {
      setLoading(true);
      //dispatch(onPostSendOtp(payload));
      const response = await sendOtpApi(payload);
      setOtpData(response);
    } catch (error) {
      toast.error(translation?.errorInSendingOTP);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (generateToken.status_code === ApiRespCode?.v3Create && templateId) {
      if (V3Data?.ClientCode) {
        sendOtp();
      }
      sessionStorage.removeItem("apiCalled");
      dispatch(onGenerateTokenSubmitReset());
    }
    if (generateToken?.isLoading) {
      setLoading(true);
    }
  }, [generateToken, templateId]);

  const handleValidOtp = async () => {
    if (otp.includes("")) {
      setError(true);
      return;
    }
    setLoading(true);
    setError(false);
    const payload = {
      otpTransactionId: otpData?.otpTransactionId,
      otp: otpValue,
      mobileNo: loginTokenData?.mobileNumber || orderData?.mobile,
      emailId: "",
    };

    try {
      const response = await validateOtpApi(payload, {
        "access-token": token?.data?.accessToken,
        clientCode: V3Data.ClientCode,
        partnerCode: V3Data.partnerCode,
      });
      setValidateOtpData(response);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const resend = () => {
    if (!templateId) return;
    setTimer(30);
    setOtp(new Array(4).fill(""));
    sendOtp();
  };

  useEffect(() => {
    if (validateOtpData?.errorMessage === "Success") {
      sessionStorage.removeItem("apiCalled");

      navigate(`/order-detail`, { state: {orderData:orderData, productId:location?.state?.productId} });
    } else if (validateOtpData?.errorCode === -1001) {
      toast.error(validateOtpData?.errorMessage);
    }
  }, [validateOtpData]);

  const formatMobileNumber = (mobile) => {
    if (!mobile) return "";
    const lastTwo = mobile.slice(-2);
    const firstTwo = mobile.slice(0, 2);
    return `+91-${firstTwo}******${lastTwo}`;
  };

  return (
    <div className="otp_modal">
      <ToastContainer />
      {loading ? (
        <Loader />
      ) : (
        <div className="custom-bg">
          <div className="modal-dialog lipmodal otp_modal">
            <div className="modal-content1 otp-modal">
              <div className="modal-body text-center">
                <div
                  className={`otp-logo my-4 pt-2 ${clientinfo?.giftLogo ? "" : "center-logo"
                    }`}
                >
                  <img
                    src={GetImageUrl(clientinfo?.logoUrl)}
                    alt="logo"
                    style={{ width: "104.48px", height: "31.87px" }}
                  />
                  {clientinfo?.giftLogo && (
                    <img
                      src={GetImageUrl(clientinfo?.giftLogo)}
                      alt="Giftlogo"
                      style={{ width: "54.18px", height: "31.09px" }}
                    />
                  )}
                </div>

                <h4 className="otpname">
                  {translation?.hi}{" "}
                  {(loginTokenData?.firstName || orderData?.fname) +
                    " " +
                    (loginTokenData?.lastName || orderData?.lname)}
                </h4>
                <p className="codeotp">
                  {translation?.enterOtpMessage}{" "}
                  {formatMobileNumber(
                    loginTokenData?.mobileNumber || orderData?.mobile
                  )}
                </p>
                <div className="verification-code">
                  <div className="verification-code--inputs">
                    {inputs.map((_, index) => (
                      <input
                        key={index}
                        type="password"
                        maxLength="1"
                        onChange={(e) => handleChange(e.target, index)}
                        value={otp[index]}
                        onKeyDown={(e) => e.key === "Enter" && handleValidOtp()}
                        style={{
                          border:
                            error && otp[index] === ""
                              ? "2px solid red"
                              : "1px solid #ccc",
                        }}
                      />
                    ))}
                  </div>
                </div>
                <p className="mt-4 mb-4" id="resendotp">
                  {timer > 0 ? translation?.resendOtp : ""}
                  {timer > 0 ? (
                    <strong id="timer">
                      {` ${translation?.in}`} {timer} {translation?.sec}
                    </strong>
                  ) : (
                    <strong id="timer" onClick={resend} className="pointer">
                      {translation?.resendOtp}
                    </strong>
                  )}
                </p>
                <div className="otpText">
                  <button
                    id="btnsubmitotp"
                    className="submitotp"
                    onClick={handleValidOtp}
                  >
                    {translation?.submit}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OTPModal;
